import React from 'react';
import {
    GroupRegistrationListPage,
    GroupRegistrationUploadPage,
    GroupRegistrationDataPage,
    GroupRegistrationDetailPage,
} from 'views/DashboardGroup';

const routes = [
    {
        path: '/dashboard/group-registration',
        element: <GroupRegistrationListPage />,
    },
    {
        path: '/dashboard/group-registration/upload',
        element: <GroupRegistrationUploadPage />,
    },
    {
        path: '/dashboard/group-registration/:id',
        element: <GroupRegistrationDataPage />,
    },
    {
        path: '/dashboard/group-registration-detail/:id',
        element: <GroupRegistrationDetailPage />,
    },
];

export default routes;
